import { render, staticRenderFns } from "./Parameters.vue?vue&type=template&id=0b81cc9c&scoped=true"
import script from "./Parameters.vue?vue&type=script&lang=ts"
export * from "./Parameters.vue?vue&type=script&lang=ts"
import style0 from "./Parameters.vue?vue&type=style&index=0&id=0b81cc9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81cc9c",
  null
  
)

export default component.exports